import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_SALES_CS } = ROLES;

const ALLOWED_ROLES_VIEW_PAYMENT_LINKS = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_SALES_CS];
const ALLOWED_ROLES_CREATE_PAYMENT_LINKS = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_SALES_CS];
const ALLOWED_ROLES_CHANGE_PAYMENT_LINK_STATUS = [ROLE_OWNER, ROLE_ADMINISTRATOR];

export function canViewPaymentLinksTables(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_PAYMENT_LINKS);
}

export function canCreatePaymentLinks(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_CREATE_PAYMENT_LINKS);
}

export function canChangePaymentLinkStatus(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_CHANGE_PAYMENT_LINK_STATUS);
}
